import axiosInstance from 'api/axiosInstance';

export const GetDDSAttachmentsForPatrol = async (
	comment_list_id: number,
): Promise<PatrolAttachment[]> => {
	let url = `/Project/WebService/CANDispatch.asmx/GetDDSAttachmentsForPatrol?commentListID=${comment_list_id}`;
	if (process.env.NODE_ENV === 'production') {
		url = '/Portal' + url;
	}
	const response = await axiosInstance.get(url);
	if (response.status !== 200) {
		throw new Error('Error fetching DDS attachments');
	}
	return response.data;
};
